import dynamic from 'next/dynamic';
import { BrandedBannerProps } from './BrandedBanner.types';

export const BrandedBanner = dynamic<BrandedBannerProps>(() => import('./BrandedBanner'));
